import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { getTime } from '../../utils/convert-time'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { AddIcon } from '@chakra-ui/icons'
import { RiPauseLine, RiPlayLine } from 'react-icons/ri'

/**Official Charts List view */
export const SongsList = ( { track, index, addSongToPlayQueue } ) => {
  // eslint-disable-next-line
  const { isPlaying, currentTrackName, playTrack, trackList } = useMusicPlayer( track, index )

  // const [shouldPlay, setShouldPlay] = useState( false )
  // const idx = trackList.indexOf( track )
  // const idxx = trackList.findIndex( ( t ) => t.id === track.id )
  const { id, name, ar, al, dt } = track

  //<td className={`${showTrackNumber ? "show" : "hide"}queue__item tracknr`}>{index + 1}</td>
  return (
    <tbody
      key={id}
      id="global__listBody">
      <tr className="queue__item">
        <td>{index + 1}</td>
        <td>
          <Link to={`/song/${id}`}>
            <p>{name}</p>
            <span>{al.name}</span>
          </Link>
        </td>
        <td>{ar[0].name}</td>
        <td className="queue__item length">
          {getTime( dt )}</td>
        <td>
          {isPlaying && currentTrackName === name
            ? <RiPauseLine
              style={{
                fill: "currentColor",
              }}
            />
            : <RiPlayLine
              style={{
                fill: "currentColor",
              }}
              onClick={() => playTrack( index )}
            />
          }
        </td>
        <td>
          <AddIcon
            fill="currentColor" w="0.7em" h="0.7em"
            onClick={() => addSongToPlayQueue( id )}
          />
        </td>
      </tr>
    </tbody>
  )
}